import React from "react";
import { RefQualificationLevelModel } from "../../../../domain/RefQualificationLevelModel";
import { ExpertiseType } from "../../../../domain/SubjectModel";
import { Paper, Typography } from "@material-ui/core";
import { ApprovalCard } from "../ApprovalCard";
import {
  useDisplaySubjects,
  useRefSubjects,
} from "../../../../hooks/useRefSubjects";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { RefQualificationTypeModel } from "../../../../domain/RefQualificationTypeMode";
import { EvaluateExperienceProps } from "../EvaluateExperience";

export const EvaluateTeachingExperienceForm: React.FC<
  EvaluateExperienceProps
> = ({ subjects, evaluations }) => {
  const useStyles = makeStyles(() => ({
    formSection: {
      padding: 30,
      paddingBottom: "40px",
      boxShadow: "0 0 19px -2px hsla(0,0%,63.9%,.3)",
      border: "1px solid #ddd",
      backgroundColor: "#fff",
      borderRadius: "3px",
      marginBottom: "50px",
    },
  }));

  const refSubjects = useRefSubjects(subjects);

  const classes = useStyles();

  const { qualLevelLookups, matchingSubjects, qualTypeLookups } =
    useDisplaySubjects(subjects, refSubjects, ExpertiseType.Teaching);

  return (
    <>
      <form data-test="teaching-experience-form">
        <Typography variant="h6">
          Teaching, Lecturing or Training Experience
        </Typography>
        <Paper className={classes.formSection}>
          <ApprovalCard
            subjects={matchingSubjects}
            evaluations={evaluations}
            levels={qualLevelLookups as unknown as RefQualificationLevelModel[]}
            qualTypes={
              qualTypeLookups as unknown as RefQualificationTypeModel[]
            }
            isAssessmentActivity={false}
            isTeachingActivity={true}
          />
        </Paper>
      </form>
    </>
  );
};
